import { Container, Switcher } from 'gu-ui-kit'
import React from 'react'
import styles from 'components/FormControls/form-controls.module.scss'

const renderSwitcher = ({
  className = '',
  label,
  meta: { submitting },
  input,
  checked,
  ...rest
}) => {
  return (
    <Container
      component="label"
      display="flex"
      flexAlign="center"
      className={className}
    >
      <Switcher
        className={styles['switcher__control']}
        {...rest}
        checked={checked}
        {...input}
        disabled={!!submitting}
      />
      <span className={styles['switcher__label']}>{label}</span>
    </Container>
  )
}

export default renderSwitcher
